import React from 'react';
import Step from "components/MainApp/atoms/Wizard/Step";


import styles from "./Step3.module.scss";
import i18n from 'i18n';
import { capitalize } from 'helpers/utils/utils_general';

const keyTitleMap = {
  type: i18n.t("packaging.type").toUpperCase(),
  name: i18n.t("name").toUpperCase(),
  measure_height: i18n.t("measure_height").toUpperCase(),
  measure_width: i18n.t("measure_width").toUpperCase(),
  measure_depth: i18n.t("measure_depth").toUpperCase(),
  volume: i18n.t("volume").toUpperCase(),
  max_weight: i18n.t("maximum.weight").toUpperCase(),
  material: i18n.t("material").toUpperCase(),
}


export class AddConfigTagStepThree extends React.Component {
  render() {
    const { embalaje, productsSelected, goBack, handleFinish, paletType } = this.props;
    const getProdtype = (quantity) => {
      if(embalaje.type.id === 'PALLET' && paletType === 'BOX'){

        if(quantity > 1) return i18n.t("boxes")
        else{
          return i18n.t("box")
        }
      }else{
        if(quantity > 1) return i18n.t("units")
        else{
          return i18n.t("unit")
        }
      }
    }
    const stepContent = (
      <form onSubmit={handleFinish}>
      <div className={styles["add-embalaje-wizard-step-three-content"]}>
        <div className={styles["section"]}>
          <div className={styles["section-title"]}>{capitalize(i18n.t("description"))}</div>
          {
            ['type', 'name'].map(
              key => {
                return embalaje[key] ? <div key={key}>
                  <div className={styles["title"]}> {keyTitleMap[key]} </div>
                  <div className={styles["value"]}> {embalaje[key].value ? embalaje[key].value : embalaje[key]}</div>
                </div> : ''
              }
            )
          }
        </div>
        <div className={styles["section"]}>
          <div className={styles["section-title"]}>{i18n.t("products")}</div>
          <div className={styles["product-list"]}>
            {
              productsSelected.map(p => <div className={styles["product"]} key={p.sku}>
                <p className={styles["product-name"]}>{p.name}  <span className={styles["quantity"]}>({p.units} {getProdtype(p.units)})</span></p>
                <p className={styles["product-brand"]}>{p.brand?.name}</p>
                <p className={styles["product-sku"]}>{capitalize(i18n.t("code"))} {p.sku}</p>

                <p></p>
              </div>)
            }
          </div>
        </div>
        <div className={styles["section"]}>
          <div className={styles["section-title"]}>{i18n.t("dimensions")}</div>
          {
            ['measure_height', 'measure_width', 'measure_depth', 'volume', 'max_weight', 'material'].map(
              key => {
                return embalaje[key] ? <div key={key}>
                  <div className={styles["title"]}> {keyTitleMap[key]} </div>
                  <div className={styles["value"]}> {embalaje[key]}</div>
                </div> : ''
              }
            )
          }
        </div>
        <div className={styles["add-embalaje-wizard-step-three-action-wrapper"]}>
          <button type="submit" className={styles["add-embalaje-wizard-step-three-action-button"]}>
            {i18n.t("finish").toUpperCase()}
          </button>
        </div>
      </div>
      </form>
    );

    return (
      <div className={styles["add-embalaje-wizard-step-three-container"]}>
        <Step title={i18n.t("confirmation")} content={stepContent} goBackFunc={goBack}></Step>
      </div>
    );
  }
}

export default AddConfigTagStepThree;
